// extracted by mini-css-extract-plugin
export default {"root":"Header_root-GXc","wrapper":"Header_wrapper-qOc","finished":"Header_finished-CNm","logo":"Header_logo-Fzg","button":"Header_button-mxg"};